<div id="login-container" fxLayout="column" fxLayoutAlign="space-evenly stretch">

    <figure id="img-login"></figure>

    <div *ngIf="!completeRegister" id="credentials-container">

        <h2> INICIAR SESIÓN </h2>

        <form #loginForm="ngForm" fxLayout="column" fxLayoutAlign="space-evenly stretch" (ngSubmit)="EmailAndPasswordlogin()">

            <mat-form-field>
                <input matInput placeholder="Ingrese correo electrónico" name="email" [formControl]="emailFormControl" required [(ngModel)]="model.email" [errorStateMatcher]="matcher">

                <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                    Por favor ingrese una dirección de correo valida
                </mat-error>

                <mat-error *ngIf="emailFormControl.hasError('required')">
                    El correo es <strong>requerido</strong>
                </mat-error>
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="Ingrese contraseña" [type]="hide ? 'password' : 'text'" name="password" required [(ngModel)]="model.password">
                
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                
            </mat-form-field>

            <a id="forgotPassword" (click)="closeDialog()">Olvidaste tu contraseña?</a>

            <button id="btn-login" mat-raised-button color="primary" [disabled]="!loginForm.valid" type='submit'>
                Iniciar Sesión
            </button>

            <div id="login-socialMedia" fxLayout="row" fxLayoutAlign="space-between center">

                <button type="button" id="btn-LoginGoogle" (click)="googleFirebaseLogin()" fxLayout="row" fxLayoutAlign="space-evenly center">
                    <figure></figure>
                    <span>Iniciar con<br/>
                        Google</span>
                </button>

                <button type="button" id="btn-loginFacebook" (click)="facebookFirebaseLogin()" fxLayout="row" fxLayoutAlign="space-evenly center">
                    <figure></figure>
                    <span>Iniciar con<br/>
                        Facebook</span>
                </button>

            </div>

        </form>

        <p id="notCount">¿No tienes cuenta?</p>
        <!-- <a id="linkRegister" [routerLink]="['/register']" (click)="closeDialog()">Registrarse</a> -->
        <a id="linkRegister" [routerLink]="[{ outlets: { primary: ['register'], sidebar: ['register']}}]" (click)="closeDialog()">Registrarse</a>
    </div>


    <div id="contentCompleteRegister" *ngIf="completeRegister">

        <h2>¡BIENVENID@!</h2>

        <p id="namePerson"> {{firebaseAuthService.publicUserToCreate.displayName}}</p>

        <p> Nos alegra mucho que llegaras hasta acá, ahora solo nos falta completar algunos datos y puedes empezar a disfrutar de TuGessi.com</p>

        <h3>¿ Continúamos ?</h3>

        <div id="btnsActions" fxLayout="row" fxLayoutAlign="space-between center">

            <button id="btn-cancel-register" mat-raised-button color="secondary" (click)="cancelSocialNetworkRegister()">
                No, Cancele el registro</button>

            <button id="btn-complete-register" mat-raised-button color="primary" (click)="goToSocialNetworkRegister()"> Sí, Continuemos</button>
        </div>

    </div>